import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const LanguageContext = createContext(null);

const translations = {
  // Header / Nav
  'nav.home': { hi: 'होम', en: 'Home' },
  'nav.horoscope': { hi: 'राशिफल', en: 'Horoscope' },
  'nav.panchang': { hi: 'पंचांग', en: 'Panchang' },
  'nav.services': { hi: 'सेवाएं', en: 'Services' },
  'nav.kundli': { hi: 'कुंडली', en: 'Kundli' },
  'nav.gunmilan': { hi: 'गुण मिलान', en: 'Gun Milan' },
  'nav.vastu': { hi: 'वास्तु', en: 'Vastu' },
  'nav.about': { hi: 'परिचय', en: 'About' },
  'nav.gallery': { hi: 'गैलरी', en: 'Gallery' },
  'nav.blog': { hi: 'ब्लॉग', en: 'Blog' },
  'nav.contact': { hi: 'संपर्क', en: 'Contact' },
  'nav.consultNow': { hi: 'परामर्श लें', en: 'Consult Now' },

  // Hero
  'hero.badge': { hi: '33+ वर्षों का वैदिक अनुभव', en: '33+ Years of Vedic Excellence' },
  'hero.heading1': { hi: 'अपने भाग्य को', en: 'Unlock Your' },
  'hero.heading2': { hi: 'जानें और बदलें', en: 'Cosmic Destiny' },
  'hero.subtitle': { hi: 'ज्योतिष, वास्तु एवं कॉस्मिक हीलिंग', en: 'Astrology, Vastu & Cosmic Healing' },
  'hero.desc': { 
    hi: 'वैदिक ज्योतिष, वास्तु शास्त्र और कॉस्मिक हीलिंग के माध्यम से दिव्य मार्गदर्शन। अपने जीवन को पवित्र ज्ञान और व्यक्तिगत उपायों से बदलें।',
    en: 'Divine guidance through Vedic Astrology, Vastu & Cosmic Healing. Transform your life with sacred wisdom and personalized remedies.'
  },
  'hero.bookConsultation': { hi: 'परामर्श बुक करें', en: 'Book Consultation' },
  'hero.freeKundli': { hi: 'मुफ्त कुंडली', en: 'Free Kundli' },
  'hero.years': { hi: 'वर्षों का अनुभव', en: 'Years' },
  'hero.clients': { hi: 'संतुष्ट ग्राहक', en: 'Clients' },
  'hero.countries': { hi: 'देशों में सेवा', en: 'Countries' },

  // Horoscope
  'horoscope.tag': { hi: 'आज का राशिफल', en: 'Daily Horoscope' },
  'horoscope.title1': { hi: 'आज का', en: "Today's" },
  'horoscope.title2': { hi: 'राशिफल', en: 'Rashifal' },
  'horoscope.selectSign': { hi: 'अपनी राशि चुनें', en: 'Select your zodiac sign' },
  'horoscope.luck': { hi: 'भाग्य', en: 'Luck' },
  'horoscope.love': { hi: 'प्रेम', en: 'Love' },
  'horoscope.career': { hi: 'करियर', en: 'Career' },
  'horoscope.detailedReading': { hi: 'विस्तृत परामर्श लें', en: 'Get Detailed Reading' },

  // Panchang
  'panchang.tag': { hi: 'आज का पंचांग', en: 'Daily Panchang' },
  'panchang.title1': { hi: 'आज का', en: "Today's" },
  'panchang.title2': { hi: 'पंचांग', en: 'Panchang' },
  'panchang.loading': { hi: 'पंचांग लोड हो रहा है...', en: 'Loading Panchang...' },
  'panchang.details': { hi: 'पंचांग विवरण', en: 'Panchang Details' },
  'panchang.day': { hi: 'वार', en: 'Day' },
  'panchang.tithi': { hi: 'तिथि', en: 'Tithi' },
  'panchang.nakshatra': { hi: 'नक्षत्र', en: 'Nakshatra' },
  'panchang.yoga': { hi: 'योग', en: 'Yoga' },
  'panchang.karana': { hi: 'करण', en: 'Karana' },
  'panchang.nextTithi': { hi: 'अगली तिथि', en: 'Next Tithi' },
  'panchang.after': { hi: 'के बाद', en: 'after' },
  'panchang.until': { hi: 'तक', en: 'until' },
  'panchang.sunrise': { hi: 'सूर्योदय', en: 'Sunrise' },
  'panchang.sunset': { hi: 'सूर्यास्त', en: 'Sunset' },
  'panchang.moonrise': { hi: 'चंद्रोदय', en: 'Moonrise' },
  'panchang.moonset': { hi: 'चंद्रास्त', en: 'Moonset' },
  'panchang.rahukaal': { hi: 'राहुकाल', en: 'Rahukaal' },
  'panchang.rahukaalDesc': { hi: 'अशुभ समय', en: 'Inauspicious Time' },
  'panchang.todayRahukaal': { hi: 'आज का राहुकाल', en: "Today's Rahukaal" },
  'panchang.noAuspicious': { hi: 'इस समय शुभ कार्य न करें', en: 'Avoid auspicious work during this time' },
  'panchang.yamaganda': { hi: 'यमगण्डम', en: 'Yamaganda' },
  'panchang.gulika': { hi: 'गुलिक काल', en: 'Gulika Kaal' },
  'panchang.muhurat': { hi: 'शुभ मुहूर्त सलाह', en: 'Auspicious Time Advice' },
  'panchang.muhuratDesc': { 
    hi: 'राहुकाल और यमगण्डम के समय में शुभ कार्य जैसे नया व्यापार, यात्रा, या महत्वपूर्ण निर्णय न लें। सटीक मुहूर्त के लिए अपनी कुंडली के अनुसार परामर्श लें।',
    en: 'Avoid starting new business, travel, or important decisions during Rahukaal and Yamaganda. Consult your Kundli for precise auspicious timings.'
  },
  'panchang.muhuratCta': { hi: 'मुहूर्त परामर्श लें', en: 'Get Muhurat Consultation' },

  // Services
  'services.tag': { hi: 'हमारी सेवाएं', en: 'Our Services' },
  'services.title1': { hi: 'पवित्र', en: 'Sacred' },
  'services.title2': { hi: 'ज्योतिष सेवाएं', en: 'Astrology Services' },
  'services.desc': { hi: 'जीवन के हर पहलू के लिए दिव्य समाधान', en: 'Comprehensive divine solutions for every aspect of your life' },
  'services.consult': { hi: 'परामर्श लें', en: 'Consult' },

  // About
  'about.tag': { hi: 'परिचय', en: 'About Us' },
  'about.title1': { hi: '33+ वर्षों का', en: '33+ Years of' },
  'about.title2': { hi: 'दिव्य ज्ञान', en: 'Divine Wisdom' },
  'about.desc': {
    hi: 'विवेक मुद्गल (ज्योतिषी, वास्तु विशेषज्ञ एवं कॉस्मिक हीलर) के दिव्य मार्गदर्शन में विराट एस्ट्रो में आपका स्वागत है। 33+ वर्षों के पवित्र अभ्यास के साथ, हमने हजारों लोगों को सही मार्ग खोजने में मदद की है।',
    en: 'Welcome to ViratAstro - guided by Vivek Mudgal (Astrologer, Vastu Expert & Cosmic Healer). With over 33 years of sacred practice, we\'ve helped thousands find their true path.'
  },
  'about.awards': { hi: 'पुरस्कार', en: 'Awards' },
  'about.books': { hi: 'पुस्तकें', en: 'Books' },

  // Vastu
  'vastu.tag': { hi: 'वास्तु शास्त्र', en: 'Vastu Shastra' },
  'vastu.title1': { hi: 'वास्तु से', en: 'Transform with' },
  'vastu.title2': { hi: 'जीवन बदलें', en: 'Vastu Shastra' },
  'vastu.cta': { hi: 'वास्तु परामर्श लें', en: 'Get Vastu Consultation' },

  // Book Consultation
  'book.title': { hi: 'परामर्श बुक करें', en: 'Book Consultation' },
  'book.name': { hi: 'पूरा नाम', en: 'Full Name' },
  'book.phone': { hi: 'फोन नंबर', en: 'Phone Number' },
  'book.email': { hi: 'ईमेल', en: 'Email' },
  'book.service': { hi: 'सेवा चुनें', en: 'Select Service' },
  'book.message': { hi: 'संदेश', en: 'Your Message' },
  'book.submit': { hi: 'अभी बुक करें', en: 'Book Now' },
  'book.success': { hi: 'बुकिंग सफल! हम जल्द संपर्क करेंगे।', en: 'Booking successful! We will contact you soon.' },

  // Contact
  'contact.tag': { hi: 'संपर्क करें', en: 'Contact Us' },
  'contact.title': { hi: 'हमसे जुड़ें', en: 'Get In Touch' },

  // Footer
  'footer.quickLinks': { hi: 'त्वरित लिंक', en: 'Quick Links' },
  'footer.contact': { hi: 'संपर्क', en: 'Contact' },
  'footer.shloka': { hi: '"तमसो मा ज्योतिर्गमय" — अंधकार से प्रकाश की ओर ले चलो', en: '"Tamaso Ma Jyotirgamaya" — Lead me from darkness to light' },

  // Blog
  'blog.tag': { hi: 'ज्योतिष ब्लॉग', en: 'Astrology Blog' },
  'blog.title': { hi: 'ज्योतिष लेख', en: 'Astrology Articles' },
  'blog.readMore': { hi: 'और पढ़ें', en: 'Read More' },
  'blog.allLang': { hi: 'सभी', en: 'All' },
  'blog.hindi': { hi: 'हिंदी', en: 'Hindi' },
  'blog.english': { hi: 'English', en: 'English' },

  // Testimonials
  'testimonials.tag': { hi: 'ग्राहक अनुभव', en: 'Client Experiences' },
  'testimonials.title': { hi: 'विश्वास की कहानियाँ', en: 'Stories of Trust' },

  // Gallery
  'gallery.tag': { hi: 'फोटो गैलरी', en: 'Photo Gallery' },
  'gallery.title': { hi: 'दिव्य पल', en: 'Divine Moments' },

  // Gun Milan
  'gunmilan.title': { hi: 'गुण मिलान', en: 'Gun Milan' },

  // Common
  'common.learnMore': { hi: 'और जानें', en: 'Learn More' },
  'common.viewAll': { hi: 'सभी देखें', en: 'View All' },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem('viratastro_lang') || 'hi';
    } catch {
      return 'hi';
    }
  });

  // Feb 08, 2026 P0 — sync <html lang="..."> so CSS `:lang(hi)` rules kick in.
  // This is what enables the Devanagari-safe letter-spacing override in index.css
  // that prevents iPhone Safari from breaking conjuncts/matras.
  useEffect(() => {
    try {
      document.documentElement.lang = lang === 'hi' ? 'hi' : 'en';
    } catch { /* ignore in SSR / test envs */ }
  }, [lang]);

  const toggleLang = useCallback(() => {
    setLang(prev => {
      const next = prev === 'hi' ? 'en' : 'hi';
      try { localStorage.setItem('viratastro_lang', next); } catch {}
      return next;
    });
  }, []);

  const t = useCallback((key) => {
    const entry = translations[key];
    if (!entry) return key;
    return entry[lang] || entry['en'] || key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLang must be used within a LanguageProvider');
  }
  return context;
}
